module.exports = __webpack_public_path__ + "static/media/reschedule.b1504ec6.svg";